import { render, staticRenderFns } from "./AdminFaqAdd.vue?vue&type=template&id=e5c24e96"
import script from "./AdminFaqAdd.vue?vue&type=script&lang=js"
export * from "./AdminFaqAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports